import React, {useContext, useState, useEffect} from "react";

import {Form, Select, Input, Typography} from "antd";

import {properties} from "../../../properties";
import {ModalWindow} from "./ModalWindow";
import {CurrentUserContext} from "../../../contexts/AuthContext";

export function ArchiveScopeModal({isModalVisible, setIsModalVisible, scope, onFinish, spin, setLoading}) {
    const close = () => setIsModalVisible(false);
	const [form] = Form.useForm();

	const user = useContext(CurrentUserContext);

	const handleCancel = () => {
		closeModal();
	};

	form.setFieldsValue({
        scope_name: scope?.name || "",
        scope_dsc: scope?.description || "",
        archived_by: user.email(),
        add_info: "",
    });

	return (
		<ModalWindow
			width={900}
			title={`Archive Scope`}
			isModalVisible={isModalVisible}
			scrollVisible={false}
			onCancel={close}
			modalProps={{
				okText: "Submit",
				cancelText: "Cancel",
				okButtonProps: {form: "scopeArchiveForm", key: "submit", htmlType: "submit"},
			}}>
			<Form onFinish={(values) => onFinish(values, scope?._id)}
			      form={form} id="scopeArchiveForm"
			>
				<Form.Item label=<b>Scope Name</b> name="scope_name">
				      <Typography.Text><b> {form.getFieldValue("scope_name")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Scope Description</b> name="scope_dsc">
				    <Typography.Text><b> {form.getFieldValue("scope_dsc")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Archived by</b> name="archived_by">
				    <Typography.Text><b> {form.getFieldValue("archived_by")} </b></Typography.Text>
				</Form.Item>
				<Form.Item label=<b>Additional Information</b> name="add_info">
					<Input/>
				</Form.Item>
			</Form>
		</ModalWindow>
	);
}

